/* ALVA guard: never let a visitor land on a Section Rendering API fragment (a page with no styles at all).
   Shopify's {% form %} tags copy the CURRENT url into a hidden "return_to" field. When the form was rendered
   through the Section Rendering API (the header, the cart drawer...), that url ends in ?section_id=... and
   submitting the form (e.g. the language switch) sends the visitor to the bare section HTML.
   This keeps every return_to field clean, whether the form is submitted by the browser or by a script. */
(function () {
  if (window.__alvaGuard) return;
  window.__alvaGuard = true;

  var BAD_PARAMS = ['section_id', 'sections', 'sections_url'];

  function clean(value) {
    if (!value || value.indexOf('section') === -1) return value;
    try {
      var url = new URL(value, location.origin);
      var dirty = false;
      BAD_PARAMS.forEach(function (name) {
        if (url.searchParams.has(name)) { url.searchParams.delete(name); dirty = true; }
      });
      return dirty ? url.pathname + url.search + url.hash : value;
    } catch (e) {
      return location.pathname;
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var fields = scope.querySelectorAll('input[name="return_to"]');
    for (var i = 0; i < fields.length; i++) {
      var fixed = clean(fields[i].value);
      if (fixed !== fields[i].value) fields[i].value = fixed;
    }
  }

  scan(document);

  // The header is hydrated after load, so new forms can appear at any time.
  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () { scan(document); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('submit', function (event) { scan(event.target); }, true);
})();
